import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

interface EditEmailProps {
    visible: boolean;
    onHide: () => void;
    onUpdate: () => void;
    loading: boolean;
    data: any;
    errors: any;
    onChange: (e: any, name: string) => void;
}

const EditEmail = ({
    visible,
    onHide,
    onUpdate,
    loading,
    data,
    errors,
    onChange
}: EditEmailProps) => {
    return (
        <Dialog
            visible={visible}
            className="mx-3 lg:mx-0"
            style={{ width: '450px' }}
            header={'Edit Email'}
            draggable={false}
            modal
            footer={
                <div className="flex pt-2 align-items-center justify-content-end">
                    <Button
                        label="Cancel"
                        icon="pi pi-times"
                        className="mr-2 p-button-secondary"
                        onClick={onHide}
                    />
                    <Button
                        label="Update"
                        icon="pi pi-check"
                        onClick={onUpdate}
                        className="common-primary-button"
                        loading={loading}
                    />
                </div>
            }
            onHide={onHide}
        >
            <div className="grid p-fluid formgrid">
                {/* Email */}
                <div className="field col-12 md:col-11">
                    <label htmlFor="email">Email *</label>
                    <div className="input-effect-div">
                        <InputText
                            value={data.email || ''}
                            name="email"
                            autoComplete="off"
                            placeholder="Enter Email"
                            onChange={(e) => onChange(e, 'email')}
                            className={errors?.['email'] && 'p-invalid'}
                        />
                        <span className="focus-bg"></span>
                    </div>
                    <small className="p-invalid-txt">
                        {errors?.['email']}
                    </small>
                </div>
            </div>
        </Dialog>
    );
};

export default EditEmail;